import * as yup from 'yup'

import constants from 'constants/index'

const schema = (volumetryType) => {
  const volumetryRequire =
    volumetryType === constants.dataProcess.STORY_MODE_DEFINED_TYPE

  return yup.object().shape({
    departmentId: yup.string(),
    code: yup.string().required(),
    version: yup.string().required(),
    name: yup.string().required(),
    finality: yup.string().required(),
    ...(volumetryRequire && {
      value: yup.number().typeError('Precisa ser um número').required(),
      volumetry: yup.string().required(),
      deadlineJustification: yup.string().required(),
    }),
    dataProcessDataSources: yup.array().nullable(),
    sourceDescription: yup
      .number()
      .nullable()
      .transform((newValue) => {
        if (isNaN(parseInt(newValue))) {
          return null
        }

        return newValue
      }),
    sourceDescriptionAnother: yup.string().nullable(),
  })
}

export default schema
